import { Container } from 'reactstrap';
import ModifFormDoplnek from '../comp/ModifFormDoplnek'

function NewDoplnek() {
    return (
    <Container>
        <ModifFormDoplnek edit={false} />
    </Container>)
}
export default NewDoplnek